import { useState, useEffect, useCallback } from "react";
import Cookies from "js-cookie";
import axiosInstance from "../../../services/axiosInstance";
import { getPropertiesByUserId } from "../../../services/propertyService";

const INITIAL_FILTERS = {
  title: "",
  propertyType: "",
  isSold: "all",
};

export function useMyProperties() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchMyProperties = useCallback(async () => {
    try {
      setLoading(true);
      const user = JSON.parse(Cookies.get("user") || "{}");
      if (!user?.id) return;

      const res = await getPropertiesByUserId(user.id, filters, page, 6);
      setProperties(res.properties || []);
      setTotalPages(res.pagination?.totalPages || 1);
    } catch (error) {
      console.error("Lỗi khi tải bất động sản đã đăng:", error);
    } finally {
      setLoading(false);
    }
  }, [page, filters]);

  useEffect(() => {
    fetchMyProperties();
  }, [fetchMyProperties]);

  const handleFilterChange = (e) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bạn có chắc chắn muốn xóa bất động sản này?")) return;
    try {
      await axiosInstance.delete(`/properties/${id}`);
      setProperties((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Lỗi khi xóa bất động sản:", err);
    }
  };

  return {
    properties,
    loading,
    filters,
    page,
    totalPages,
    handleFilterChange,
    handleDelete,
    setPage,
  };
}